require('./bootstrap');

// Import modules...

import { createApp, h } from 'vue';
import { createInertiaApp, Link } from '@inertiajs/vue3';
import { createI18n } from "vue-i18n";

// import * as Sentry from "@sentry/vue";


import mitt from 'mitt';
const EventBus = mitt();
import VueFeather from 'vue-feather';
import VueTippy from 'vue-tippy';
import 'tippy.js/dist/tippy.css'
import 'tippy.js/animations/shift-away.css'
import "tippy.js/themes/light.css"
import { VueClipboard } from '@soerenmartius/vue3-clipboard'
import vClickOutside from "click-outside-vue3"
import moshaToast from 'mosha-vue-toastify'

import 'mosha-vue-toastify/dist/style.css'
import '../css/custom-css.css'

// import adapter from 'webrtc-adapter'

//import { createI18n } from "vue-i18n";
//import VueI18n from "vue-i18n"

// import hljs from 'highlight.js/lib/core';
// import javascript from 'highlight.js/lib/languages/javascript';
// import hljsVuePlugin from "@highlightjs/vue-plugin";
// import 'highlight.js/styles/github-dark.css'
// hljs.registerLanguage('javascript', javascript);

// import 'highlight.js/styles/github-dark.css'
// import hljsVuePlugin from "@highlightjs/vue-plugin"


//import 'highlight.js/styles/stackoverflow-light.css'
// import 'highlight.js/styles/github-dark.css'
// import hljs from 'highlight.js/lib/core';
// import javascript from 'highlight.js/lib/languages/javascript';
// import hljsVuePlugin from "@highlightjs/vue-plugin";
// hljs.registerLanguage('javascript', javascript);
import hljs from 'highlight.js/lib/common'

//const el = document.getElementById('app');

// 2. Create i18n instance with options
// const i18n = VueI18n.createI18n({
//   locale: 'ja', // set locale
//   fallbackLocale: 'en', // set fallback locale
//   messages, // set locale messages
//   // If you need to specify other options, you can set other options
//   // ...
// })

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Birdie';

import DocsLink from '@/Components/UI/DocsLink'
//import ExploreFlowsLink from '@/Components/UI/ExploreFlowsLink'

/*const app = createApp({
    render: () =>
        h(InertiaApp, {
            initialPage: JSON.parse(el.dataset.page),
            resolveComponent: (name) => require(`./Pages/${name}`).default,
        }),
})
.mixin({ methods: { route } })
.use(InertiaPlugin)
.component(VueFeather.name, VueFeather)
.use(VueClipboard)
.use(vClickOutside)
.use(moshaToast)
//.use(VueI18n)
//.use(hljsVuePlugin)
.use(VueTippy, {defaultProps: { animation: 'shift-away' }});
app.config.globalProperties.EventBus = EventBus;
app.mount(el);*/

// import VueNativeSock from "vue-native-websocket-vue3";


// DELETE visitble dataset: later
const elData = document.getElementById('app');


createInertiaApp({
    progress: { color: '#4B5563' },
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => require(`./Pages/${name}.vue`),
    setup({ el, App, props, plugin }) {

        const i18n = createI18n({
            locale: props.initialPage.props.locale || navigator.language.split("-")[0] || "en",
            fallbackLocale: "en",
            messages: loadLocaleMessages(),
            globalInjection: true,
        });
        const appZest = createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(i18n)
            .component('inertia-link', Link)
            .component(VueFeather.name, VueFeather)
            .use(VueClipboard)
            .use(moshaToast)
            //.use(adapter)
            .use(VueTippy, { defaultProps: { animation: 'shift-away' } })
            .use(vClickOutside)
            .use(hljs)
            //.component('highlightjs', hljsVuePlugin.component)
            //.use(hljsVuePlugin)
            // .use(VueNativeSock, '', {
            //     connectManually: true,
            //     reconnection: true,
            //     reconnectionAttempts: 10,
            //     reconnectionDelay: 3000
            // })
            .mixin({ methods: { route } });

        appZest.config.globalProperties.EventBus = EventBus;
        //dayjs.locale(i18n.global.locale)
        //appZest.config.globalProperties.$dayjs = dayjs;
        appZest.component("DocsLink", DocsLink);
        //appZest.component("ExploreFlowsLink", ExploreFlowsLink);


        // Sentry.init({
        //     app:appZest,
        //     dsn: "https://1bf2d8486f7a4096b2caf4e7027132b0@o739267.ingest.sentry.io/4505211617280000",
        //     integrations: [
        //       new Sentry.BrowserTracing({
        //       }),
        //     ],
        //     tracesSampleRate: 0.5,
        // });


        appZest.mount(el);

        // DELETE visitble dataset Now
        delete elData.dataset.page;

        return appZest;

    },
});



function loadLocaleMessages() {
    const locales = require.context(
        //"../locales",
        "../lang/integrations",
        true,
        /[A-Za-z0-9-_,\s]+\.json$/i
    );
    const messages = {};
    locales.keys().forEach((key) => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            const locale = matched[1];
            messages[locale] = locales(key);
        }
    });
    return messages;
}
